<template>
  <div class="loader d-flex justify-center align-center">
    <v-progress-circular :size="50" :color="color" indeterminate>
    </v-progress-circular>
  </div>
</template>

<script>
export default {
  name: "Loader",
  props: {
    color: {
      type: String,
      default: "primary"
    }
  }
}
</script>

<style>
  .loader {
    height: 70vh;
  }
</style>